import { OptionsType } from '../../../helpers/issue/maturity';

export function variousFormatter(abbreviate = false, caps = false) {
  return data => {
    const values: any[] = data.value;

    if (values.length > 1) {
      const word = abbreviate ? 'Var' : 'Various';

      return caps ? word.toUpperCase() : word;
    } else {
      return values[0] === OptionsType.Blank ? '' : values[0];
    }
  };
}
